import Callback from './components/callback';
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Layout from './pages/layout';
import ErrorPage from './pages/Error';
import HomePage from './pages/homepage';
import AuthProvider from './provider/authprovider';
import './App.css';
import LandingPage from './components/LandingPage/LandingPage';
import NotFound from './components/Theme/NotFound';
import EditApplication from './components/EditApplication/EditApplication';
import UserManagement from './components/UserManagement/UserManagement';

function App() {
  const router = createBrowserRouter([{
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/landingpage', element: <LandingPage /> },
      { path: '/ROS/internal/equinor', element: <LandingPage /> , caseSensitive: true},
      { path: '/callback', element: <Callback /> },
      { path: '/manage-applications', element: <EditApplication /> },
      { path: '/manage-users', element: <UserManagement /> }
    ]
  },
    { path: '*', element: <NotFound /> }
  ]);

  return (
    <div>
      <div>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </div>
    </div>
  );
};

export default App;
